import {
  GET_YUSA_OVERNIGHT_CAMP_ENROLLMENT_AND_OCCUPANCY_DETAILS,
  GET_YUSA_OVERNIGHT_CAMP_PARTICIPANTS_DETAILS,
  POST_YUSA_OVERNIGHT_CAMP_ENROLLMENT_AND_OCCUPANCY_DETAILS,
  POST_YUSA_OVERNIGHT_CAMP_PARTICIPANTS_DETAILS
} from '@config/api-config';
import { asyncRequest } from '@config/http-config';
import * as types from './types';

// eslint-disable-next-line import/prefer-default-export
export const getOvernightCampParticipantsAndEnrollment =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_ENROLLMENT_AND_OCCUPANCY_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_ENROLLMENT_AND_OCCUPANCY_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataEnrollmentAndOccupancy =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_YUSA_OVERNIGHT_CAMP_ENROLLMENT_AND_OCCUPANCY_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_POST_ENROLLMENT_AND_OCCUPANCY_FAILURE,
        payload: error
      }),
      dispatch
    });

export const getOvernightCampDataParticipantsList =
  (branchNumber, reportBatchId, year) => (dispatch, getState) =>
    asyncRequest({
      url: GET_YUSA_OVERNIGHT_CAMP_PARTICIPANTS_DETAILS(
        branchNumber,
        reportBatchId,
        year
      ),
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_GET_PARTICIPANTS_FAILURE,
        payload: error
      }),
      dispatch
    });

export const postOvernightCampDataParticipants =
  payloadBody => (dispatch, getState) =>
    asyncRequest({
      url: POST_YUSA_OVERNIGHT_CAMP_PARTICIPANTS_DETAILS(),
      method: 'POST',
      data: payloadBody,
      successAction: data => ({
        type: types.YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_SUCCESS,
        async: true,
        payload: data,
        state: getState()
      }),
      failureAction: error => ({
        type: types.YUSA_OVERNIGHT_CAMP_POST_PARTICIPANTS_FAILURE,
        payload: error
      }),
      dispatch
    });

export const resetReduxState = key => ({
  type: 'RESET_KEY',
  payload: { key }
});
